import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "hoem",
        component: () => import('@/components/index/index.vue'),
    },
    {
        path: "/cooperate",
        name: "cooperate",
        component: () => import("@/components/cooperate/index.vue"),
    },
    {
        path: "/submitto",
        name: "submitto",
        component: () => import("@/components/submitto/index.vue"),
    },

];

const Router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});

export default Router;



